export const RATE_KANBAN_POLL_MAX_START_FOR_REVIEW = 3;
